import type { DataTypeLocator } from '@helo/cms'
import { flow } from '@helo/utils'

import type { QueryOutput } from '../../Query'
import { RenderPipeline } from '../../RenderPipeline'
import { ChartSeries } from '../ChartSeries'
import {
  type ChartDataOptions,
  type ChartNullValueBehavior,
  chartDataOptions,
} from './ChartData.options'
import { ChartDataInputParts, ChartDataOutputParts } from './ChartData.parts'

export type {
  ChartDataOptions,
  ChartDataSort,
  ChartNullValueBehavior,
} from './ChartData.options'
export { chartDataOptions } from './ChartData.options'

export type {
  ChartSeriesRendererProps,
  ChartSeriesVisualizationProps,
  ResolvedChartSeries,
} from '../ChartSeries'

/** Pipeline input consumed by ChartData.setup. */
export type ChartDataInput = ChartDataOptions

export type ChartDataPoint = {
  x: string
  y: number | null
}

export type ChartDataSlice = {
  chartData: Record<string, unknown>[] | undefined
  dimensionLocator: DataTypeLocator
  dimensionKey: string
  dimensionLabel?: string
  nullValueBehavior: ChartNullValueBehavior
}

/** Pipeline output slice — resolved rows and dimension. */
export type ChartDataOutput = {
  data: ChartDataSlice
}

export type ChartDataPriorOutput = QueryOutput

const chartDataSetup = () =>
  RenderPipeline.createFeatureSetup<
    ChartDataInput,
    ChartDataOutput,
    ChartDataPriorOutput
  >(flow(ChartDataInputParts.setupInput(), ChartDataOutputParts.setData()))

export const ChartData = {
  options: chartDataOptions,
  setup: chartDataSetup,
  SeriesRenderer: ChartSeries.SeriesRenderer,
}
